import { Link } from "react-router-dom";
import '../Jugadores.css'

function Maradona()
{
    return(
    <section className="main">
        <img className="banner" src='https://www.cronica.com.ar/__export/1671452598485/sites/cronica/img/2022/12/19/diego_besando_la_copa_del_mundo_x1x_crop1671452537914.png_514393756.png'></img>
        <div className="Nombre">DIEGO ARMANDO MARADONA</div>
    </section>
    )
}

export default Maradona;